import * as React from 'react';
import classNames from 'classnames';

import { Link } from '../Link';

import * as styles from './ProjectsBlock.css';
import * as gridStyles from '../../utils/grid.css';

interface IProjectsBlockProps {
  onLinkClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const ProjectsBlock: React.FC<IProjectsBlockProps> = ({ onLinkClick }) => (
  <div className={classNames(styles['c-footer-projects'], gridStyles['cg-col-24'])}>
    <div className={gridStyles['cg-row']}>
      <div className={classNames(styles['c-footer-projects-item'], gridStyles['cg-col-16'])}>
        <Link href="/" onClick={onLinkClick}>
          <b>Cian.ru</b>
        </Link>
        &nbsp;—&nbsp;достоверная база данных о продаже и аренде жилой, загородной и&nbsp;коммерческой недвижимости
      </div>
      <div className={gridStyles['cg-col-8']}>
        <Link href="http://emls.ru" onClick={onLinkClick}>
          <b>EMLS.ru</b>
        </Link>
        &nbsp;— сайт недвижимости Санкт-Петербурга
      </div>
    </div>
  </div>
);
